import React from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {Box, Tab, Tabs} from '@mui/material';
import GlobalSnackbar from '../../shared-components/GlobalSnackbar';

const SchoolManagementPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const tab = location.pathname.startsWith('/management/templates')
        ? 1
        : location.pathname.startsWith('/management/training') ? 2 : 0;

    return (
        <>
            <Box sx={{px: 3, borderBottom: '1px solid #e5e7eb'}}>
                <Tabs
                    value={tab}
                    onChange={(_, value) => navigate(['/management', '/management/templates', '/management/training'][value])}
                >
                    <Tab label="School Workspaces" data-testid="tab-school-workspaces"/>
                    <Tab label="Form Templates" data-testid="tab-form-templates"/>
                    <Tab label="Training Progress" data-testid="tab-training-progress"/>
                </Tabs>
            </Box>
            <Box sx={{px: 3}}>
                <Outlet/>
            </Box>
            <GlobalSnackbar/>
        </>
    );
};

export default SchoolManagementPage;
